import { DRIVER_FIELDS, FIELDS } from './constants';
import { defaultDriver, defaultInsurer } from './resources';

export const getUniqueCustomerIds = ({ nodes }) => {
  return nodes.reduce((acc, node) => {
    const isUniqueCustomerId = !acc.find((customerId) => {
      return String(customerId) === String(node.customerId);
    });

    if (isUniqueCustomerId) {
      acc.push(node.customerId);
    }

    return acc;
  }, []);
};

export const changeDriver = ({ id, state: { [FIELDS.DRIVERS]: drivers } }, callback) => {
  return drivers.reduce((acc, driver) => {
    const { [DRIVER_FIELDS.ID]: driverId } = driver;

    let target = driver;

    if (id === driverId) {
      target = callback(structuredClone(driver));
    }

    acc.push(target);

    return acc;
  }, []);
};

export const getChangedDrivers = (state, { key, value, id }) => {
  return changeDriver({ id, state }, ({ [DRIVER_FIELDS.EMPTY]: _, ...result }) => {
    return { ...result, [key]: value };
  });
};

export const createNewDriverId = (state, addingId = null) => {
  if (addingId) {
    return addingId;
  }

  let { [FIELDS.DRIVERS]: drivers } = state ?? {};

  drivers ||= [];

  let result = 0;

  for (const { [DRIVER_FIELDS.ID]: id } of drivers) {
    result = Math.max(id, result);
  }

  return result + 1;
};

export const createNewDriver = (id, isEmpty = false, driverData = {}) => {
  const addons = isEmpty ? { [DRIVER_FIELDS.EMPTY]: true } : {};

  return {
    ...defaultDriver,
    [DRIVER_FIELDS.ID]: id,
    ...addons,
    ...driverData,
    [DRIVER_FIELDS.IS_NEW]: true,
  };
};

export const createInsurer = () => {
  return { ...defaultInsurer, insurerDadataInfo: {}, errors: {} };
};

export const createNewDriverFromConfidant = (driverData) => {
  const driver = {
    id: driverData.id,
    fio: driverData.fullName,
    bday: driverData.birthDate.replaceAll('.', ''),
    status: 'confidant',
  };

  return { ...defaultDriver, ...driver };
};
